import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { CompanyStorageService } from './company.storage';

@Injectable({ providedIn: 'root' })
export class CompanyGuard implements CanActivate {

  constructor(
    private companyStorage: CompanyStorageService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const verifiedToken = this.companyStorage.getVerifyToken();
    const userToken = localStorage.getItem('usertoken');

    if (verifiedToken && userToken) {
      this.router.navigateByUrl('/home');
      return false;
    }

    if (!verifiedToken) {
      this.router.navigateByUrl('/binding-company');
      return false;
    }

    return true;
  }
}